// Deck list helpers for the home, the picker and my decks. Pure, apart from the stored selection.
import { t } from '../../i18n';

export const TYPES = ['question', 'answer'];

// One helper for every count line: deck headings and MyDecks rows.
export const cardCount = n => t('deck.cards', { count: n });

// The picker lists starter decks, and own and shared decks that hold cards.
export const pickable = (decks, type) => decks.filter(d => d.type === type && (d.starter || d.card_count > 0));

// "starter", "own" or "shared". Starters and View shares both carry access "view", so `starter` decides first.
export const group = d => (d.starter ? 'starter' : d.access === 'owner' ? 'own' : 'shared');

export const answerCardTotal = (decks, ids) =>
  decks.filter(d => d.type === 'answer' && ids.includes(d.id)).reduce((sum, d) => sum + d.card_count, 0);

const pickKey = uid => `deckPick:${uid}`;
const isIds = value => Array.isArray(value) && value.every(id => typeof id === 'string');

// A stored value of any other shape counts as none; storage can throw (private mode, blocked site data).
export const readPick = uid => {
  try {
    const value = JSON.parse(localStorage.getItem(pickKey(uid)));
    return value && isIds(value.question) && isIds(value.answer) ? { question: value.question, answer: value.answer } : null;
  } catch (e) {
    return null;
  }
};

export const savePick = (uid, selected) => {
  try { localStorage.setItem(pickKey(uid), JSON.stringify(selected)); } catch (e) { /* see readPick */ }
};

export const forgetPick = uid => {
  try { localStorage.removeItem(pickKey(uid)); } catch (e) { /* see readPick */ }
};

// Keeps the selected ids each type still lists, in list order.
export const intersect = (selected, decks) => Object.fromEntries(TYPES.map(type => {
  const ids = pickable(decks, type).map(d => d.id);
  return [type, ids.filter(id => selected[type].includes(id))];
}));

// First deck load of a session: the stored pick, or every starter deck. `dropped` marks each type the
// stored pick left empty because its decks are gone.
export const initialPick = (decks, stored) => {
  if (!stored) {
    return {
      selected: Object.fromEntries(TYPES.map(type => [type, pickable(decks, type).filter(d => d.starter).map(d => d.id)])),
      dropped: { question: false, answer: false },
    };
  }
  const selected = intersect(stored, decks);
  return {
    selected,
    dropped: Object.fromEntries(TYPES.map(type => [type, stored[type].length > 0 && selected[type].length === 0])),
  };
};
